// istanbul ignore file
import { useAuthContext } from '@distribusion/owl-auth'
import { useCallback } from 'react'

import { useUserAuth } from '@hooks/userAuthProvider/provider'
import { useSettings } from '@queries/settings'

type LogoutOption = 'noRedirect'

const useLogout = () => {
  const { setSessionId } = useAuthContext()
  const { setUser, setIsAuthenticated } = useUserAuth()
  const [{ logo }] = useSettings()

  const logout = useCallback(
    (option?: LogoutOption) => {
      const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'

      if (isLoggedIn) {
        const redirectUrl = logo?.redirectionUrl

        localStorage.removeItem('isLoggedIn')
        setSessionId('')
        setUser(null)
        setIsAuthenticated(false)

        if (option !== 'noRedirect' && redirectUrl) {
          window.location.href = redirectUrl
        }
      }
    },
    [logo, setSessionId, setUser, setIsAuthenticated],
  )

  return { logout }
}

export default useLogout
